module.exports = __webpack_public_path__ + "2cf0165faa992fb663092a06f2441678.svg";


//////////////////
// WEBPACK FOOTER
// ./images/back_arrow.svg
// module id = 54
// module chunks = 0